module.exports = __webpack_public_path__ + "static/img/teamMt.419cdfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/teamMt.png
// module id = lF/Z
// module chunks = 0